import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

export const Header = styled('header')`
  color: ${({ theme }) => theme.color.spaceGray};
  h1 {
    padding-top: 24px;
    padding-left: 16px;
    ${({ theme }) => theme.typography.mega}
    letter-spacing: -0.02em;
    font-weight: 700;
    line-height: 36px;
    margin: auto;
    ${media.lgUp`
      font-size: 3.2rem;
    `}
    ${media.mdDown`
      padding-top: 16px;
      padding-bottom: 16px;
    `}
  }
`;

export const IFrame = styled('iframe')`
  width: 100%;
  max-width: 660px;
  overflow: hidden;
  background: transparent;
`;

export const PodcastListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
`;

export const InnerContainer = styled('section')`
  position: relative;
  max-width: ${({ theme }) => theme.xlMin};
  width: 100%;
  ${media.lgUp`
    padding: ${({ theme }) =>
      `${theme.x2spacePx}px ${theme.x3spacePx}px ${theme.x3spacePx}px`};
	`};
`;

export const PodcastWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 55px;
`;

export const Title = styled('h2')`
  ${(props) => props.theme.typography.xLargeStrong}
  color: ${({ theme }) => theme.color.spaceGray};
  margin-top: 16px;
`;

export const Description = styled('div')`
  ${(props) => props.theme.typography.base}
  color: ${(props) => props.theme.color.spaceGray};
  margin-bottom: 28px;

  ul > li {
    margin-left: 16px;
    list-style-type: disc;
  }

  ol > li {
    margin-left: 16px;
    list-style-type: decimal;
  }
`;

export const SidebarContainer = styled(Row)`
  padding: 16px;

  svg {
    width: 100%;
  }
`;

export const SidebarTitle = styled.h3`
  ${(props) => props.theme.typography.baseStrong}
  color: ${({ theme }) => theme.color.spaceGray};
  margin-top: 16px;
  text-align: center;
`;

export const SidebarText = styled.p`
  ${(props) => props.theme.typography.xSmall}
  color: ${({ theme }) => theme.color.spaceGrayRGBA(0.7)};
  margin-top: 16px;
  text-align: center;
`;

export const YouTubeTitle = styled.h3`
  ${(props) => props.theme.typography.xSmallStrong}
  color: ${({ theme }) => theme.color.spaceGrayRGBA(0.7)};
  margin-top: 16px;
  margin-bottom: 8px;
  text-align: center;
`;

export const ShareClubImage = styled.img`
  object-fit: cover;
  border-radius: 8px;
  width: 100%;
`;
